import React from "react";
import { twMerge } from "tailwind-merge";

import { CaptureItemState, CaptureItemStatus } from "@components/ChartCapture/types";

const STATUS_CLASS: Record<CaptureItemStatus, string> = {
  pending: "bg-limestone-50",
  capturing: "bg-limestone-200 animate-pulse",
  saving: "bg-limestone-400 animate-pulse",
  done: "bg-limestone-600",
  error: "bg-red-600",
};

/**
 * One segment per item, colored by its pipeline status. A red segment marks an
 * item whose chart couldn't be captured or saved; its label + reason surface on
 * hover.
 */
export const CaptureProgressIndicator: React.FC<{ items: CaptureItemState[] }> = ({ items }) => {
  if (items.length === 0) return null;
  return (
    <div
      data-testid="capture-progress-indicator"
      className="flex gap-0.25 animate-in fade-in slide-in-from-top-8 duration-200"
    >
      {items.map((item) => (
        <div
          key={item.id}
          title={item.status === "error" ? `${item.label}: ${item.error ?? "Failed"}` : item.label}
          className={twMerge("flex-1 h-3 rounded-xs transition border border-border-strong", STATUS_CLASS[item.status])}
        />
      ))}
    </div>
  );
};
